import { render, staticRenderFns } from "./UCSAActivities.vue?vue&type=template&id=3dce6c2e&scoped=true&"
import script from "./UCSAActivities.vue?vue&type=script&lang=js&"
export * from "./UCSAActivities.vue?vue&type=script&lang=js&"
import style0 from "./UCSAActivities.vue?vue&type=style&index=0&id=3dce6c2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dce6c2e",
  null
  
)

export default component.exports